import classNames from 'classnames';
import { ReactNode } from 'react';

import CloseButton from '../buttons/CloseButton';

import styles from '../../styles/popups/dialog.module.css';

interface DialogProps {
    children: ReactNode;
    closeable?: boolean;
    onClose?: () => void | null;
    className?: string | null;
}

function Dialog({ children, closeable = false, onClose, className = null }: DialogProps) {
    return (
        <div className={classNames([styles.container, className])}>
            {children}
            {closeable ? <CloseButton onClick={onClose} className={styles.closeButton} /> : null}
        </div>
    );
}

export default Dialog;
